import React, { useEffect, useRef, useState } from "react"
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'
import axios from "axios"

import { IsEmptyString } from "./GeneralFunctions";
import { OAuthApiStartPolling } from "../ExternalApi/OAuthApi"
import { SigninApiGetTokenGntel } from "../ExternalApi/SigninApi"
import { GetGntelOauthUrl, GetGntelSites, GetGntelTokensFromAuthorizationCode, GntelSaveSite, GntelAccessToken, GntelRefreshToken, GntelJsonRpcApiUrl } from "./Gntel"

import CloudCTIPng from '../Assets/SignIn/CloudCTI.png'
import UserPng from '../Assets/SignIn/User.png'

import "../css/Signin.css"

//Subclasses

const SigninGntel = (props) => {

    const [mError, SetError] = useState("")
    const [mEmail, SetEmail] = useState("")

    const [mWaitingForState, SetWaitingForState] = useState("")
    const [mOAuthWindow, SetOAuthWindow] = useState(null) 

    const EmailKeyDown = (evt) => {
        if ((evt.key === "Enter") && !IsEmptyString(mEmail)) 
        {
            SignIn()
        }
    }

    const RandomState = () => 
    {
        let Result = "client2020WEB"

        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for ( var i = 0; i < 27; i++ ) 
        {
            Result += characters.charAt(Math.floor(Math.random() * characters.length))
        }
        
        return Result
    }

    const OAuthPollResult = async (aResult, aValue, aOAuthWindow) =>
    {
        try 
        { 
            if (aOAuthWindow !== null)
            {
                aOAuthWindow.close() 
                aOAuthWindow = null
                SetOAuthWindow(null)
            }
        } 
        catch {}

        if (aResult)
        {
            console.log("OAuthPollResult success: " + JSON.stringify(aValue))
            if (aValue.Code)
            {
                if (GetGntelTokensFromAuthorizationCode(aValue.Code))
                { 
                    const result = await SigninApiGetTokenGntel(mEmail, GntelAccessToken(), GntelRefreshToken(), GntelJsonRpcApiUrl())
                    if (result === null)
                    {
                        SetError("Signin failed")
                    }
                    else if (result.SecurityToken)
                    {
                        localStorage.setItem("securitytoken", result.SecurityToken)
                        window.location.href = props.RedirectUrl
                    }
                    else if (result.Exception)
                    {
                        SetError("Signin failed: " + result.Exception)
                    }                    
                }
                else
                {
                    SetError("Failed to retrieve gnTel tokens")  
                }
            }
            else
            {
                SetError("Failed to authenticate. No authorizationcode found")  
            }
        }
        else
        {
            console.log("OAuthPollResult error",aValue)  
            SetError("Failed to authenticate")          
        }
    }

    const SignIn = async () => {
        SetError("")
        const sites = await GetGntelSites(mEmail)
        console.log(sites)
        if ((sites !== null) && (sites !== undefined) && (sites.length > 0))
        {
            GntelSaveSite(sites[0])
            
            SetError("Waiting for OAUTH verification")
            StartOAuth()
        }
        else
        {
            SetError("This email has no associated gnTel sites")
        }
    }

    const StartOAuth = () =>
    {
        const State = RandomState()        
        const OAuthWindow = window.open(GetGntelOauthUrl(State,mEmail), "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
        
        SetOAuthWindow(OAuthWindow)
        OAuthApiStartPolling(State, OAuthPollResult, OAuthWindow)
        SetWaitingForState(State)
    }

    return (
        <table align="center" valign="top" style={{ width: '90%' }}>        
        <tbody>
        <tr>
            <td align="center" style={{ paddingTop: '10px' }}>
            <div className="signinform">    
                <img src={CloudCTIPng}/><br clear="all"/>
                <br/>
                <h4>Enter your gnTel email address</h4>
                {!IsEmptyString(mError) ? <div style={{ color: 'red'}}>{mError}</div> : <span/>}
                <hr/>
                <table width="100%" cellPadding="2" cellSpacing="2">
                    <tbody>
                        <tr>
                            <td width="30"><img src={UserPng}/></td>
                            <td width="*"><input type="text" placeholder="Email" value={mEmail} onChange={(evt) => SetEmail(evt.target.value)} onKeyDown={EmailKeyDown} className="signintextbox"/></td>
                            <td width="24"/>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <Button variant="primary" onClick={() => SignIn()}>Sign In</Button>
            </div>
            </td>
        </tr>
        </tbody>
        </table>
    ); 
}

SigninGntel.propTypes = {
    ProductName: PropTypes.string,
    RedirectUrl: PropTypes.string //The link to open after writing in the localStorage: its own link without onetime params 
}

export default SigninGntel;